import React from 'react';
const ContentBlockDataContext = React.createContext(null);
const ContentBlockDataConsumer = ContentBlockDataContext.Consumer;
const ContentBlockDataProvider = ({ children, data, }) => {
    return (React.createElement(ContentBlockDataContext.Provider, { value: { data } }, children));
};
export { ContentBlockDataProvider, ContentBlockDataConsumer };
export default ContentBlockDataContext;
